const routes = {
    path: 'tiposervico',
    name: 'ModalidadeTipoServico',
    component: () => import('./ModalidadeTipoServico.vue'),
    children: [
        {
            path: 'inserir',
            name: 'Modalidade_Tipo_Servico_Inserir',
            component: () => import('./ModalidadeTipoServicoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            },
        },
        {
            path: ':id/atualizar',
            name: 'Modalidade_Tipo_Servico_Atualizar',
            component: () => import('./ModalidadeTipoServicoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            },
        },
    ],
    meta: {
        rules: ['SOL-001'],
    },
};

export default routes;
